/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { colors } from '@blend/consumer-components';
import { css, StyleSheet } from 'aphrodite';
import bsr_logo from './bsr_logo.svg';
import { headerHeight } from '@components/DesktopHeader/DesktopHeader';

const distanceFromTop = 12;

const styles = StyleSheet.create({
  logoWrapper: {
    display: 'flex',
    backgroundColor: colors.white,
    alignItems: 'center',
    width: 274,
  },
  logoImage: {
    height: headerHeight - 2 * distanceFromTop,
    marginLeft: 16,
  },
});

export namespace Logo {
  export interface Props {}
}

export const Logo: React.FC<Logo.Props> = () => {
  return (
    <div className={css(styles.logoWrapper)} data-dd-privacy="allow">
      <img src={bsr_logo} className={css(styles.logoImage)} alt={'Blend Signing Room'} />
    </div>
  );
};
